var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 12V14.5838C29.52 15.6625 32.3333 19.0239 32.3333 23C32.3333 26.9761 29.52 30.325 25.6667 31.4037V34C31 32.8586 35 28.3683 35 23C35 17.6317 31 13.1414 25.6667 12ZM29 23C29 20.7799 27.6667 18.8734 25.6667 17.9453V28.0171C27.6667 27.1266 29 25.2075 29 23ZM11 19.2372V26.7628H16.3333L23 33.0342V12.9658L16.3333 19.2372H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/Audio.ace1877421a8f8307c8a35da15e352bc.svg";
export { ForwardRef as ReactComponent };